import React from "react";
import { Tooltip } from "react-tooltip";

export const MedicationName = ({ med }) => {
  return (
    <span>
      {med.name}
      {med.c2 && (
        <sup
          className="text-[tomato] capitalize"
          data-tooltip-content="Controlled Substance"
          data-tooltip-id="c2"
        >
          {med.c2.toLowerCase() === "yes" ? "[C2]" : ""}
        </sup>
      )}
      <Tooltip
        place="top"
        effect="solid"
        id="c2"
        className="capitalize !text-xs !font-normal"
      />
    </span>
  );
};


export const RxMedicationName = ({ rx }) => {
  return (
    <span>
      {rx.medication_name}
      {rx.c2 && (
        <sup
          className="text-[tomato] capitalize"
          data-tooltip-content="Controlled Substance"
          data-tooltip-id="c2"
        >
          {rx.c2.toLowerCase() === "yes" ? "[C2]" : ""}
        </sup>
      )}
      <Tooltip
        place="top"
        effect="solid"
        id="c2"
        className="capitalize !text-xs !font-normal"
      />
    </span>
  );
};
